module.exports = __webpack_public_path__ + "img/movil1.33a90fe0.jpg";